import { API_ROOT_URL } from '../config';
import axios from 'axios';

export const WhitelabelService = {
	fetchWhitelabel,
	setWhitelabel,
};

function fetchWhitelabel() {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/project/`, requestOptions).then((response) => response.json());
}

function setWhitelabel(data, id='') {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
			data,
		},
	};
	//return fetch(`${API_ROOT_URL}/administrator/project/`, requestOptions).then((response) => response.json());
	if (id === '') {
		return axios
			.post(`${API_ROOT_URL}/administrator/project/`, data, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + token,
				},
			})
			.then((response) => response);
	} else {
		return axios
			.put(`${API_ROOT_URL}/administrator/project/${id}/`, data, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + token,
				},
			})
			.then((response) => response);
	}
}



// WEBPACK FOOTER //
// ./src/services/whitelabel.service.js